import styled from "styled-components";
import { ReactComponent as CancelIcon } from "../assets/cancel.svg";

const PopUpBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const PopUpBox = styled.div`
  position: relative;
  z-index: 101;
  width: 500px;
  height: 300px;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`;

const PopUpLayout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const PopUpCancelButton = styled.button`
  position: absolute;
  width: 40px;
  height: 40px;
  background-color: transparent;
  top: 0;
  right: 0;
  margin: 10px;
  border: none;
  cursor: pointer;
`;

const PopUpScreen = ({ children, setClose }) => {
  return (
    <PopUpBackground>
      <PopUpBox>
        <PopUpCancelButton
          onClick={() => {
            setClose(false);
          }}
        >
          <CancelIcon style={{ width: "100%" }} />
        </PopUpCancelButton>
        {children}
      </PopUpBox>
    </PopUpBackground>
  );
};

export {
  PopUpScreen,
  PopUpLayout,
  PopUpCancelButton,
  PopUpBackground,
  PopUpBox,
};
